import { Box, Checkbox, Typography } from "@material-ui/core";

export default function RepresentativeCard({
  representative,
  checked,
  onChange,
  disabled,
}) {
  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Checkbox checked={checked} onChange={onChange} disabled={disabled} />
      <Typography
        variant="h6"
        style={{
          fontSize: "1rem",
          textTransform: "uppercase",
          margin: 0,
          color: "gray",
        }}
      >
        {representative.Nome}
      </Typography>
    </Box>
  );
}
